<template>
  <section class="section-container d-flex justify-content-center align-items-center">
    <div class="card">
      <div class="main-container card-body">
        <div class="head-container text-center">
          <img src="../assets/logo-rmutl2.png" alt="logo" width="100" class="m-3" />
          <h4 class="">RMUTL Check-In</h4>
          <h5 class="text-mute text-12 m-b-15">เข้าระบบโดย Account มทร.ล้านนา</h5>
        </div>
        <form class="form-horizontal needs-validation" novalidate id="form-login">
          <div class="m-b-10">
            <input
              type="text"
              v-model="username"
              class="form-control form-input-bg"
              id="tb-rfname"
              placeholder="username"
              autocomplete="off"
              required
              @keyup.enter="checkForm"
            />
            <div class="invalid-feedback">
              Username is required
            </div>
          </div>
          <div class="m-b-10">
            <input
              type="password"
              v-model="password"
              class="form-control form-input-bg"
              id="tb-rfpwd"
              placeholder="password"
              autocomplete="off"
              required
              @keyup.enter="checkForm"
            />
            <div class="invalid-feedback">
              Password is required
            </div>
          </div>
          <div class="d-grid gap-2">
            <button type="button" @click="checkForm" class="btn btn-secondary">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                style="margin-top: -4px !important;"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M4 8v-2a2 2 0 0 1 2 -2h2" />
                <path d="M4 16v2a2 2 0 0 0 2 2h2" />
                <path d="M16 4h2a2 2 0 0 1 2 2v2" />
                <path d="M16 20h2a2 2 0 0 0 2 -2v-2" />
                <rect x="8" y="11" width="8" height="5" rx="1" />
                <path d="M10 11v-2a2 2 0 1 1 4 0v2" />
              </svg>
              เข้าสู่ระบบ
            </button>
          </div>
        </form>
        <div class="note-container text-12 m-t-15" v-html="contact.description"></div>
        <div class="credit-container text-center text-mute text-10 m-t-10">
          พัฒนาโดย{{ contact.team_develop }}<br />
          อัพเดทล่าสุด {{ dateTimeFormat(last_update) }}<br />
          ระบบปฏิบัติการ {{ appCode }}
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import apis from '../models/apis'
import Swal from 'sweetalert2'

export default {
  data() {
    return {
      username: '',
      password: '',
      contact: {},
      appCode: ''
    }
  },
  created() {
    this.checkOAuth()
    this.getContact()
    this.appCode = navigator.platform
  },
  mounted() {
    $('#form-login').removeClass('was-validated')
  },
  methods: {
    getContact() {
      this.$store.state.is_loading = true
      apis.getContact(
        this.$store.state.api_url,
        { headers: { 'Access-Token': this.$store.state.public_token } },
        result => {
          if (result.response === true) {
            this.contact = result.data
          }
          this.$store.state.is_loading = false
        },
        error => {
          this.$store.state.is_loading = false
          console.log(error.message)
        }
      )
    },
    checkForm() {
      var $form_data = $('#form-login')
      if (!$form_data[0].checkValidity()) {
        $('#form-login').addClass('was-validated')
      } else {
        this.authLogin()
      }
    },
    authLogin() {
      this.$store.state.is_loading = true
      var obj = {
        username: this.username,
        password: this.password,
        agent: navigator.userAgent + ' Platform: ' + navigator.platform
      }
      apis.Login(
        this.$store.state.api_url,
        obj,
        { headers: { 'Access-Token': this.$store.state.public_token } },
        result => {
          if (result.response === true) {
            localStorage.refresh_token = result.refresh_token
            this.$store.state.is_loading = false
            window.location = '/checkin'
          } else {
            this.$store.state.is_loading = false
            this.unSuccess(result.message)
          }
        },
        error => {
          this.$store.state.is_loading = false
          this.unSuccess(error.message)
        }
      )
    },
    unSuccess(message) {
      Swal.fire({
        title: 'เกิดข้อผิดพลาดบางอย่าง',
        text: message,
        icon: 'error',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'ลองใหม่อีกครั้ง',
        showCancelButton: false,
        allowOutsideClick: false
      }).then(result => {})
    }
  }
}
</script>

<style scoped>
.section-container {
  width: 100wh !important;
  height: 100vh !important;
}
.main-container {
  width: 330px !important;
}
.head-container {
  margin: 0 !important;
  padding: 0 !important;
}
.info-container {
  margin: 0 !important;
  padding: 0 !important;
}
.note-container {
  margin: 0 !important;
  padding: 6px !important;
  border: 1px solid rgba(101, 109, 119, 0.16);
  border-radius: 5px;
  font-size: 12px;
  background: #fafbfd;
}
.credit-container {
  margin: 0 !important;
  padding: 0 !important;
}
.btn-secondary {
  background: #a1780f !important;
  border-color: #a1780f !important;
}
.text-10 {
  font-size: 10px !important;
}
.text-12 {
  font-size: 12px !important;
}
.text-mute {
  color: #727272 !important;
}
.m-t-5 {
  margin-top: 5px !important;
}
.m-t-10 {
  margin-top: 10px !important;
}
.m-t-15 {
  margin-top: 15px !important;
}
.m-b-5 {
  margin-bottom: 5px !important;
}
.m-b-10 {
  margin-bottom: 10px !important;
}
.m-b-15 {
  margin-bottom: 15px !important;
}
input {
  font-family: 'Roboto';
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue